import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _asyncToGenerator from'@babel/runtime/helpers/asyncToGenerator';import _regeneratorRuntime from'@babel/runtime/regenerator';import {getAnalytics,getPageData,getUserData}from'./adobeAnalytics-functions.js';import {ADOBE_PAGE_LOAD,ADOBE_LINK_CLICK,ADOBE_TRANSACTION,ADOBE_REGISTRATION,ADOBE_LOGIN,ADOBE_ERROR}from'./adobeAnalytics-constants.js';/**
 * Sends page load analytics data to the adobe data layer
 * @param {Object} data
 */
function sendAdobeAnalyticsPageLoad(_x) {
  return _sendAdobeAnalyticsPageLoad.apply(this, arguments);
}

/**
 * Sends link click analytics data to the adobe data layer
 * @param {Object} data
 */
function _sendAdobeAnalyticsPageLoad() {
  _sendAdobeAnalyticsPageLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var analytics, pageInfo, userInfo;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            analytics = getAnalytics();
            if (!data) {
              _context.next = 11;
              break;
            }
            pageInfo = data.pageInfo, userInfo = data.userInfo;
            _context.t0 = analytics;
            _context.t1 = ADOBE_PAGE_LOAD;
            _context.t2 = getPageData(pageInfo.pageName, pageInfo.language);
            _context.next = 8;
            return getUserData(userInfo);
          case 8:
            _context.t3 = _context.sent;
            _context.t4 = {
              event: _context.t1,
              page: _context.t2,
              user: _context.t3
            };
            _context.t0.push.call(_context.t0, _context.t4);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendAdobeAnalyticsPageLoad.apply(this, arguments);
}
var sendAdobeAnalyticsClick = function sendAdobeAnalyticsClick(data) {
  var analytics = getAnalytics();
  var click = data.click;
  if (click) {
    analytics.push({
      event: ADOBE_LINK_CLICK,
      click: click
    });
  }
};

/**
 * Sends transaction analytics data to the adobe data layer
 * @param {Object} data
 */
var sendAdobeAnalyticsTransaction = function sendAdobeAnalyticsTransaction(eventName, data) {
  var analytics = getAnalytics();
  var transaction = data.transaction,
    error = data.error;
  if (eventName && transaction) {
    analytics.push(_objectSpread({
      event: ADOBE_TRANSACTION[eventName],
      transaction: transaction
    }, eventName === 'ERROR' && error && {
      error: error
    }));
  }
};

/**
 * Sends registration analytics data to the adobe data layer
 * @param {Object} data
 */
var sendAdobeAnalyticsRegistration = function sendAdobeAnalyticsRegistration(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var analytics = getAnalytics();
  var error = data.error;
  if (eventName) {
    analytics.push(_objectSpread({
      event: ADOBE_REGISTRATION[eventName]
    }, eventName === 'ERROR' && error && {
      error: error
    }));
  }
};

/**
 * Sends login analytics data to the adobe data layer
 * @param {Object} data
 */
var sendAdobeAnalyticsLogin = function sendAdobeAnalyticsLogin(eventName, data) {
  var analytics = getAnalytics();
  var login = data.login,
    error = data.error;
  if (eventName && login) {
    analytics.push(_objectSpread({
      event: ADOBE_LOGIN[eventName],
      login: login
    }, eventName === 'ERROR' && error && {
      error: error
    }));
  }
};

/**
 * Sends error analytics data to the adobe data layer
 * @param {Object} data
 */
var sendAdobeAnalyticsError = function sendAdobeAnalyticsError(data) {
  var analytics = getAnalytics();
  var error = data.error;
  if (error) {
    analytics.push({
      event: ADOBE_ERROR,
      error: error
    });
  }
};export{sendAdobeAnalyticsClick,sendAdobeAnalyticsError,sendAdobeAnalyticsLogin,sendAdobeAnalyticsPageLoad,sendAdobeAnalyticsRegistration,sendAdobeAnalyticsTransaction};